import store from '../index.js';

export const SWITCHONAUDIO = Symbol("SWITCHONAUDIO");
export const SHOWMENU = Symbol("SHOWMENU");
export const MIDIACCESS = Symbol("MIDIACCESS");
export const UPDATEPOOL = Symbol("UPDATEPOOL");
export const UPDATEBOUNCE = Symbol("UPDATEBOUNCE");
export const CREATERIPPLE = Symbol("CREATERIPPLE");
export const SQUAREONMOUSEDOWN = Symbol("SQUAREONMOUSEDOWN");
export const SQUAREONMOUSEUP = Symbol("SQUAREONMOUSEUP");
export const SQUAREONMOUSEOVER = Symbol("SQUAREONMOUSEOVER");
export const DIALONMOUSEMOVE = Symbol("DIALONMOUSEMOVE");
export const DIALONMOUSEDOWN = Symbol("DIALONMOUSEDOWN");
export const BALL = Symbol("BALL");
export const ANIMATIONID = Symbol("ANIMATIONID");
export const TRANSPOSETONES = Symbol("TRANSPOSETONES");
export const CUECHORD = Symbol("CUECHORD");
export const CLEAR = Symbol("CLEAR");
export const LOOPERONCLICKBUTTON = Symbol("LOOPERONCLICKBUTTON");
export const LOOPERONCLICKFADER = Symbol("LOOPERONCLICKFADER");
export const LOOPERONCLICKMUTE = Symbol("LOOPERONCLICKMUTE");
export const SETMIDIDEVICESLOOPER = Symbol("SETMIDIDEVICESLOOPER");

export const switchOnAudio = () => ({
	type: SWITCHONAUDIO,
})

export const showMenu = (bool) => ({
    type: SHOWMENU,
    bool
})

export const midiAccess = (WebMidi) => ({
	type: MIDIACCESS,
	WebMidi
})

export const updatePool = () => ({
	type: UPDATEPOOL,
})

export const updateBounce = () => ({
	type: UPDATEBOUNCE,
})

export const squareOnMouseDown = (event, i, isHeld) => ({
	type: SQUAREONMOUSEDOWN,
	event,
    i,
    isHeld
})

export const squareOnMouseUp = () => ({
	type: SQUAREONMOUSEUP,
})

export const squareOnMouseOver = (event, i) => ({
	type: SQUAREONMOUSEOVER,
	event,
	i
})

export const dialOnMouseMove = (event, i) => ({
	type: DIALONMOUSEMOVE,
	event,
	i
})

export const dialOnMouseDown = (i, bool) => ({
	type: DIALONMOUSEDOWN,
	i,
	bool,
})

export const createBall = (event, r=60) => (dispatch, getState) => {
	let balls = getState().getIn(['bounce', 'balls']);
	dispatch(ball(event, r));
	if(!balls.size) bounceAnimation(); // if first ball start animation
}

export const ball = (event, r) => ({
	type: BALL,
    event,
    r
})

export const bounceAnimation = () => {
	let bounce = store.getState().get('bounce');
	if (bounce.get('balls').size) {
		// call animation recursively, each time sending id to the state
		store.dispatch( animationID( requestAnimationFrame(bounceAnimation) ) );
	} else {
		cancelAnimationFrame(bounce.get('animationID'));
	}
};

export const animationID = (animationID) => ({
	type: ANIMATIONID,
	animationID,
})

export const transposeTones = (i) => ({
	type: TRANSPOSETONES,
	i,
})

export const cueChord = (i) => ({
	type: CUECHORD,
	i,
})

export const clear = () => ({
	type: CLEAR,
})

export const looperOnClickButton = (id, loopr) => ({
	type: LOOPERONCLICKBUTTON,
	id, 
	loopr
})

export const looperOnClickFader = (e, id, loopr) => ({
	type: LOOPERONCLICKFADER,
	e,
	id, 
	loopr
})

export const looperOnClickMute = (id, loopr) => ({
	type: LOOPERONCLICKMUTE,
	id, 
	loopr
})

export const setMidiDevicesLooper = (i, isInput) => ({
	type: SETMIDIDEVICESLOOPER,
	i, 
	isInput
})


// WEBPACK FOOTER //
// ./src/data/actions.js